import type { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { Flex, type BoxProps } from '../Core';
import type { IconName } from '../Icons';
import { Icon } from '../Icons';
import { Text, type TextProps } from '../Text';

export interface SectionTitleProps extends BoxProps {
  title: string;
  showNumber?: boolean;
  icon?: IconName;
  suffix?: ReactNode;
  fontSize?: TextProps['size'];
  textTransform?: TextProps['transform'];
  fontWeight?: TextProps['weight'];
}

/**
 * A section title with optional numbering, divider, icon, and trailing content.
 */
export function SectionTitle({
  title,
  fontSize = 'fontSizeSm',
  textTransform,
  fontWeight = 'normal',
  color = 'colorTextImportant',
  showNumber = false,
  icon,
  suffix,
  ...rest
}: SectionTitleProps) {
  return (
    <SectionTitleBox showNumber={showNumber} gap="spacing8" alignItems="center" {...rest}>
      {icon && <Icon icon={icon} />}
      <TitleWrapper transform={textTransform} weight={fontWeight} color={color} size={fontSize} whiteSpace="nowrap">
        {title}
      </TitleWrapper>
      {suffix}
    </SectionTitleBox>
  );
}

const TitleWrapper = styled(Text)``;

const SectionTitleBox = styled(Flex)<{ showNumber: boolean }>`
  ${({ showNumber }) =>
    showNumber &&
    css`
      counter-increment: number;

      ${TitleWrapper} {
        &:before {
          color: ${({ theme }) => theme.colorTextDefault};
          content: counter(number) '. ';
        }
      }
    `}
`;
